import { LanguageOptions } from "../../Base/LanguageOptions";
import { ActionList } from "../Quest/Actions";
import { GoalsList } from "./Goals";
import { MapPoi } from "../Base/MapPoi";
import { MiniGame, MINIGAME_TYPE } from "./Puzzle";
import { QUEST_CG_SECTIONS } from "./QuestsEnum";
import { QuestPoiWarning } from "@/models/Errors/QuestPoiWarning";
import { QuestPoiError } from "@/models/Errors/QuestPoiError";

export interface QuestMapPoi extends MapPoi {
  type: string;
  mapStatus: string;
  tutorial: boolean;
  desc?: LanguageOptions;
  image?: string;
  content3D?: {
    fbxPaths?: string; // storage path for 3dModel TBC
  };

  actionGoalRef?: ActionRefData[];
  contentGroups: {
    [key: string]: {
      [QUEST_CG_SECTIONS.DIALOG1]: Quest_CG_DialogSection;
      [QUEST_CG_SECTIONS.MINIGAME]?: Quest_CG_MinigameSection;
      [QUEST_CG_SECTIONS.DIALOG2]?: Quest_CG_DialogSection;
      [QUEST_CG_SECTIONS.EXIT_GOALS]?: GoalsList;
    };
  };
  issues?: Issues;
}

export interface Issues {
  warn?: QuestPoiWarning;
  err?: QuestPoiError;
}

export interface ActionRefData {
  id: string;
  questionId?: string;
  helperPath: string;
  path: string;
}

export interface Quest_CG_DialogSection {
  imgs: string;
  title: LanguageOptions;
  questID?: string;
  txt: LanguageOptions;
  audio?: LanguageOptions;
  actions?: ActionList;
  questions?: { [key: string]: Dialog_Questions };
}

export interface Quest_CG_MinigameSection {
  type: MINIGAME_TYPE;
  intro: {
    imgs: string;
    title: LanguageOptions;
    txt: LanguageOptions;
    audio: LanguageOptions;
  };
  title: LanguageOptions;
  puzzle: MiniGame;
  actions?: ActionList;
  denyForfeit?: boolean;
}

export interface Dialog_Questions {
  id: string;
  q: LanguageOptions;
  a: LanguageOptions;
  actions?: ActionList;
  cost?: { id: string; value: number };
}

export const MAP_STATUS = ["active", "inactive", "hidden", "hidden(inactive)"];
